<template>

<div class="grid grid-2">

    <div class="box-rounded">

        <div class="card-row">
            <div class="label">AutoDeals PNL</div>
            <div class="value">${{ todayProfitsMetrics.pnlRegular }}</div>
        </div>

        <div class="card-row">
            <div class="label">Close Long PNL</div>
            <div class="value">${{ todayProfitsMetrics.pnlManual }}</div>
        </div>

        <div class="card-row">
            <div class="label">Close Short PNL</div>
            <div class="value">${{ todayProfitsMetrics.pnlHedge }}</div>
        </div>

        <div class="card-row">
            <div class="label">AutoDeals</div>
            <div class="value">{{ todayProfitsMetrics.dealCount }}</div>
        </div>

        <div class="card-row">
            <div class="label">Close Long</div>
            <div class="value">{{ todayProfitsMetrics.sellManualCount }}</div>
        </div>

        <div class="card-row">
            <div class="label">Close Short</div>
            <div class="value">{{ todayProfitsMetrics.hedgeCount }}</div>
        </div>

    </div>

</div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'todayKpis',
  computed: {
    ...mapGetters(['todayProfitsMetrics']),
  }
}
</script>